import { Component, Input } from '@angular/core';
import { UserService } from '../services/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from '../model/user.class';
import { Modal } from 'angular2-modal/plugins/bootstrap';

@Component({
    selector: 'app-user-detail',
    templateUrl: './user.detail.component.html'
})
export class UserDetailComponent {
    public user: User;
    public message = '';

    constructor(public userService: UserService, private route: ActivatedRoute, private router: Router, public modal: Modal) {
        this.route.params.subscribe(
            (params) => {
                userService.get(params['id'], 'user').subscribe((user) => this.user = user as User);
            });
    }

    delete() {
        this.modal.confirm()
            .size('sm')
            .isBlocking(true)
            .showClose(true)
            .keyboard(27)
            .titleHtml('Benutzer wirklich löschen?')
            .cancelBtn('Abbrechen')
            .open().then((resultPromise) => {
                return resultPromise.result.then(
                    (result) => {
                        this.userService.delete(this.user.userId, 'user').subscribe(
                            (data) => this.router.navigate(['publisher/detail', this.user.publisher.publisherId]),
                            (err) => this.message = 'Löschen fehlgeschlagen!');
                    },
                    () => {});
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/userDetail/user.detail.component.ts